export default {
  title: "Carousel",
  subtitle: "Curated kiosk home carousel slides by region.",
  empty: "No slides for this region yet.",
  emptyWritable: "Create the first carousel slide for this region.",
  schedule: {
    always: "Always",
    from: "From",
    until: "Until",
  },
  columns: {
    slide: "Slide",
    audience: "Audience",
    schedule: "Schedule",
    status: "Status",
  },
  status: {
    visible: "Showing now",
    enabled: "Enabled",
    disabled: "Disabled",
    scheduled: "Scheduled",
    expired: "Ended",
    draft: "Draft",
  },
  statusHints: {
    draft: "Saved as a draft — not published, so it never shows on kiosks.",
    visible: "Live on kiosks right now (enabled and within the schedule).",
    scheduled:
      "Has a future start time. It will show on kiosks once that time is reached, if Enabled is on.",
    disabled:
      "Not showing on kiosks — Enabled is off, or the end time has already passed.",
  },
  categories: {
    all: "All tabs",
    select: "Select tabs",
  },
  structures: {
    all: "All structures",
    count: "{{count}} structures",
  },
  actions: {
    create: "New slide",
    edit: "Edit",
    delete: "Delete",
    dragToReorder: "Drag to reorder",
  },
  form: {
    createTitle: "New carousel slide",
    createDescription: "Slide for kiosks in the {{region}} region.",
    editTitle: "Edit carousel slide",
    sections: {
      content: "Copy",
      contentHint: "Localized title and description shown on the slide.",
      media: "Media",
      mediaHint:
        "Required to publish unless an activity is linked (then its photo is used).",
      activity: "Linked activity",
      activityHint:
        "Optional. Search and pick an activity for CTA and photo fallback.",
      targeting: "Targeting",
      targetingHint: "Which home tabs and structures see this slide.",
      visibility: "Visibility",
      visibilityHint:
        "Enable the slide and optionally schedule when it appears.",
    },
    titleLabel: "Title",
    descriptionLabel: "Description (optional)",
    photoCropDescription:
      "Frame the photo for the kiosk home carousel banner (5:2).",
    activitySearch: "Search by name, owner, or category…",
    activityNoResults: "No activities match your search.",
    activityListEmpty: "No activities in this region.",
    activityClear: "Clear linked activity",
    activityChange: "Change",
    activityInactive: "Inactive",
    showButton: "Show button to open activity",
    showButtonHint:
      "Adds a tap target on the slide that opens the linked activity details.",
    ignoreDistance: "Ignore distance",
    ignoreDistanceHint:
      "Keep this slide in the carousel even when the linked activity is far from the kiosk.",
    categoriesLabel: "Home tabs",
    categoriesHint:
      "Select at least one tab. All tabs are selected by default so the slide shows everywhere. Linking an activity defaults to its category.",
    showInAllStructures: "Show in all structures",
    showInAllStructuresHint:
      "When off, pick which structures can show this slide. When on, every structure in the region can see it.",
    structuresLabel: "Structures",
    structuresHint: "Choose which structures can show this slide.",
    enabled: "Enabled",
    enabledHint:
      "When off, the slide stays hidden on kiosks even if it is published and within the schedule.",
    startsAt: "Start at (optional)",
    endsAt: "End at (optional)",
    clearSchedule: "Clear",
    translate: "Generate translations",
    incompleteTranslationsTitle: "Translations incomplete",
    incompleteTranslationsBody:
      "Title must be filled in every language. Description must be complete in all languages or left empty. Generate the missing copy from the language you already wrote, or finish editing manually.",
  },
  delete: {
    title: "Delete slide?",
    body: "“{{title}}” will be permanently removed from the carousel.",
    confirm: "Delete",
    success: "Slide deleted",
  },
  toast: {
    created: "Slide created",
    updated: "Slide saved",
    draftSaved: "Draft saved",
    reordered: "Order updated",
  },
  errors: {
    loadError: "Could not load carousel slides",
    titleRequired: "Title is required in all languages",
    titleRequiredDraft: "Add a title in at least one language",
    descriptionPartial:
      "Description must be complete in all languages or empty",
    photoRequired: "Upload a photo, or link an activity for its photo.",
    categoriesRequired: "Select at least one home tab",
    structuresRequired:
      "Select at least one structure, or show in all structures",
    saveFailed: "Could not save slide",
  },
} as const;
